import { INSURANCE } from '@/constants';
import { useRouteSection } from '@/hooks/useRouteSection';
import { useOneMedicalMonthlyYearlyDeductible } from '@/hooks/useFeatureFlags';

// Mounts inside OpenFeatureProvider/redux Provider to keep AB test flag
// values in sync with the store. Renders nothing.
export const FeatureFlagsSync = () => {
  const routeSection = useRouteSection();

  return routeSection === INSURANCE ? <InsuranceFeatureFlagsSync /> : null;
};

const InsuranceFeatureFlagsSync = () => {
  useOneMedicalMonthlyYearlyDeductible();
  return null;
};
